import { render } from "./BackupSchedule.vue?vue&type=template&id=660b9b75&scoped=true"
import script from "./BackupSchedule.vue?vue&type=script&lang=js"
export * from "./BackupSchedule.vue?vue&type=script&lang=js"

import "./BackupSchedule.vue?vue&type=style&index=0&id=660b9b75&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660b9b75"]])

export default __exports__